import {Button} from '@superweb/ui'
import React from 'react'

import {type TariffsCountry} from '../../../../../api'
import type {Path} from '../../../../../types'
import {useCountriesModal} from '../../lib'
import {CountryModal} from '../CountryModal/CountryModal@desktop'

type Props = {
  countries: TariffsCountry[]
  path: Path
}

export function CountryButton({countries, path}: Props) {
  const {country} = path
  const {openModal} = useCountriesModal()

  return (
    <>
      <Button
        onPress={openModal}
        shape="circle"
        size="s"
        text={countries.find(item => item.id === country)?.title || ''}
        view="default"
      />

      <CountryModal countries={countries} />
    </>
  )
}
